import type { FeatureStatus, PhaseStatus, ProjectStatus } from '../../types';

type ChipColor = 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary';

export interface StatusMetaEntry {
  label: string;
  color: ChipColor;
}

/**
 * Nhãn + màu tiếng Việt cho trạng thái Dự án / Giai đoạn / Tính năng.
 * (StatusBadge dùng chung chỉ hỗ trợ AcceptanceStatus nên khu vực quản trị
 * tự định nghĩa bảng màu riêng cho 3 loại trạng thái này.)
 */
export const PROJECT_STATUS_META: Record<ProjectStatus, StatusMetaEntry> = {
  DRAFT: { label: 'Nháp', color: 'default' },
  IN_PROGRESS: { label: 'Đang thực hiện', color: 'info' },
  COMPLETED: { label: 'Hoàn thành', color: 'success' },
  ARCHIVED: { label: 'Lưu trữ', color: 'warning' },
};

export const PHASE_STATUS_META: Record<PhaseStatus, StatusMetaEntry> = {
  DRAFT: { label: 'Nháp', color: 'default' },
  ACTIVE: { label: 'Đang hoạt động', color: 'info' },
  COMPLETED: { label: 'Hoàn thành', color: 'success' },
  ARCHIVED: { label: 'Lưu trữ', color: 'warning' },
};

export const FEATURE_STATUS_META: Record<FeatureStatus, StatusMetaEntry> = {
  DRAFT: { label: 'Nháp', color: 'default' },
  ACTIVE: { label: 'Đang thực hiện', color: 'info' },
  COMPLETED: { label: 'Hoàn thành', color: 'success' },
  ARCHIVED: { label: 'Lưu trữ', color: 'warning' },
};

export const PROJECT_STATUS_OPTIONS: ProjectStatus[] = [
  'DRAFT',
  'IN_PROGRESS',
  'COMPLETED',
  'ARCHIVED',
];
export const PHASE_STATUS_OPTIONS: PhaseStatus[] = ['DRAFT', 'ACTIVE', 'COMPLETED', 'ARCHIVED'];
export const FEATURE_STATUS_OPTIONS: FeatureStatus[] = [
  'DRAFT',
  'ACTIVE',
  'COMPLETED',
  'ARCHIVED',
];
